export default __webpack_public_path__ + "static/media/marvel-cyclops.f1442408.jpg";